export { default } from './FileFolderOutline'
